export const getPluralLabel = (count: number, singularLabel: string) => {
  const noun = count === 1 ? singularLabel : `${singularLabel}s`;

  return `${count} ${noun}`;
};
